
export default function FinancialDisclosure() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      {/* ヘッダー */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center">
            <h1 className="text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#0A2540' }}>
              決算公告
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              株式会社クロポの設立公告および決算公告を掲載しています。
            </p>
          </div>
        </div>
      </section>

      {/* 公告リスト */}
      <section className="py-16 lg:py-20">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8">
              
              {/* 設立公告 */}
              <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                  <div className="mb-4 lg:mb-0">
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#0A2540' }}>
                      設立公告
                    </h3>
                    <div className="text-gray-600">
                      <p className="flex items-center mb-1">
                        <i className="ri-calendar-line mr-2" style={{ color: '#00A6D6' }}></i>
                        2025年9月
                      </p>
                      <p className="text-sm">
                        会社法第911条第3項第2号に基づく設立公告
                      </p>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <button 
                      className="text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center"
                      style={{ backgroundColor: '#00A6D6' }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#FFB800'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = '#00A6D6'}
                    >
                      <i className="ri-file-pdf-line mr-2"></i>
                      PDFを閲覧する
                    </button>
                  </div>
                </div>
              </div>

              {/* 第1期決算公告 */}
              <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                  <div className="mb-4 lg:mb-0">
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#0A2540' }}>
                      第1期決算公告
                    </h3>
                    <div className="text-gray-600">
                      <p className="flex items-center mb-1">
                        <i className="ri-calendar-line mr-2 text-gray-400"></i>
                        2026年度（予定）
                      </p>
                      <p className="text-sm">
                        決算期：2025年9月1日〜2026年8月31日
                      </p>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <button 
                      disabled 
                      className="bg-gray-300 text-gray-500 px-6 py-3 rounded-lg font-semibold cursor-not-allowed flex items-center"
                    >
                      <i className="ri-time-line mr-2"></i>
                      準備中
                    </button>
                  </div>
                </div>
              </div>

              {/* 第2期決算公告 */}
              <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                  <div className="mb-4 lg:mb-0">
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#0A2540' }}>
                      第2期決算公告
                    </h3>
                    <div className="text-gray-600">
                      <p className="flex items-center mb-1">
                        <i className="ri-calendar-line mr-2 text-gray-400"></i>
                        2027年度（予定）
                      </p>
                      <p className="text-sm">
                        決算期：2026年9月1日〜2027年8月31日
                      </p>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <button 
                      disabled 
                      className="bg-gray-300 text-gray-500 px-6 py-3 rounded-lg font-semibold cursor-not-allowed flex items-center"
                    >
                      <i className="ri-time-line mr-2"></i>
                      準備中
                    </button>
                  </div>
                </div>
              </div>

              {/* 第3期決算公告 */}
              <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-lg">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                  <div className="mb-4 lg:mb-0">
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#0A2540' }}>
                      第3期決算公告
                    </h3>
                    <div className="text-gray-600">
                      <p className="flex items-center mb-1">
                        <i className="ri-calendar-line mr-2 text-gray-400"></i>
                        2028年度（予定）
                      </p>
                      <p className="text-sm">
                        決算期：2027年9月1日〜2028年8月31日
                      </p>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <button 
                      disabled 
                      className="bg-gray-300 text-gray-500 px-6 py-3 rounded-lg font-semibold cursor-not-allowed flex items-center"
                    >
                      <i className="ri-time-line mr-2"></i>
                      準備中
                    </button>
                  </div>
                </div>
              </div>

            </div>

            {/* 注意書き */}
            <div className="mt-16 text-center">
              <div className="border rounded-lg p-6" style={{ backgroundColor: '#E6F7FF', borderColor: '#00A6D6' }}>
                <p className="text-sm" style={{ color: '#0A2540' }}>
                  <i className="ri-information-line mr-2" style={{ color: '#00A6D6' }}></i>
                  本ページに掲載する公告は、会社法第440条に基づき電子公告として公開しています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gray-50 py-16">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center">
            <div className="mb-8">
              <a 
                href="/"
                className="text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-flex items-center"
                style={{ backgroundColor: '#FFB800' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#E6A600'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#FFB800'}
              >
                <i className="ri-home-line mr-2"></i>
                株式会社クロポ コーポレートサイトへ戻る
              </a>
            </div>
            
            <div className="border-t border-gray-200 pt-8">
              <div className="text-gray-600 text-sm space-y-1">
                <p className="font-semibold" style={{ color: '#0A2540' }}>株式会社クロポ（XROPO Inc.）</p>
                <p>〒101-0041 東京都千代田区神田須田町1丁目7番8号　VORT秋葉原Ⅳ 2F</p>
                <p className="text-xs text-gray-500 mt-4">
                  © 2024 XROPO Inc. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}